import {
    MONTH_NAME_1, MONTH_NAME_10, MONTH_NAME_11, MONTH_NAME_12, MONTH_NAME_2, MONTH_NAME_3, MONTH_NAME_4,
    MONTH_NAME_5, MONTH_NAME_6, MONTH_NAME_7, MONTH_NAME_8, MONTH_NAME_9,
} from 'mk/autogenerated/translations/schemas.10890989d6fcdcb71b255da9625ec346'
import { Entity, PhotoEntity, PhotoSchema } from 'mk2/schemas';
import { schema } from 'normalizr';

// Profile

export enum PregnancyState {
    DoNotTell = 0,
    Pregnant = 1,
    Trying = 2,
    DoNotPlan = 3,
    HasChildren = 99,
}

export enum PregnantWith {
    WeDontKnow = 1,
    ItWillBeSurprise = 2,
    Boy = 3,
    Girl = 4,
    TwinsBoys = 5,
    TwinsGirls = 6,
    TwinsBoyAndGirl = 9,
    TwinsSurprise = 10,
    Triplets = 12,
}

export interface ProfileEntity extends Entity {
    avatar: PhotoEntity;
    sex: SexType;
    birthDate: string;
    residency: {
        id: number,
        name: string,
    };
    pregnancyState: PregnancyState;
    pregnantWith: PregnantWith;
    dueDate: string;
    childName: string;
    about: string;
}

export const ProfileSchema = new schema.Entity('profile', {
    avatar: PhotoSchema,
});

// Kids

export enum SexType {
    Unknown = 0,
    Girl = 1,
    Boy = 2,
}

export interface KidEntity extends Entity {
    name: string;
    birthDate: string; // datum v tvare YYYY-MM-DD
    sex: SexType;
    photo: PhotoEntity;
}

export const KidSchema = new schema.Entity('kids', {
    photo: PhotoSchema,
});

// Account

export interface AccountEntity extends Entity {
    email: string;
    emailNotifications: string;
    phoneNumber: string;
    password: string;
}

export const AccountSchema = new schema.Entity('account', {});
